// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bank';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M5.484 6.12h-2.25v6.75h2.25zm4.5 0h-2.25v6.75h2.25zm4.5 0h-2.25v6.75h2.25zm1.126 9H2.11v-1.687a.562.562 0 0 1 .562-.562h12.375a.562.562 0 0 1 .562.562zM.984 17.37h15.75M.984 15.12h15.75' />
    <path d='M15.61 3.87v1.688a.563.563 0 0 1-.563.563H2.672a.562.562 0 0 1-.563-.563V3.871L8.61.62a.564.564 0 0 1 .502 0zm-13.5 0h13.5' />
  </g>
);

export const viewBox = '0 0 18 18';
